






























































import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';

export default mixins(E2EMixin).extend({
  props: {
    cvCvSection: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    editUrl: {
      type: [String, Object],
      default: null,
    },
    addUrl: {
      type: [String, Object],
      default: null,
    },
    sortUpHandler: {
      type: Function,
      default: null,
    },
    sortDownHandler: {
      type: Function,
      default: null,
    },
  },
});
